export default __webpack_public_path__ + "static/media/06.1cd68c9d.png";